import PropTypes from "prop-types";
import { useState } from "react";
import { ChevronDown, Database } from "lucide-react";

import { buttonVariants } from "@/components/ui/button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuGroup,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import EventDatasetDialog from "routes/meta_datasets/swoogo_events/EventDatasetDialog";

const EventBulkActions = ({ selectedIds, uncheckAll }) => {
  const [isDialogOpen, setIsDialogOpen] = useState(false);

  return (
    <>
      <DropdownMenu>
        <DropdownMenuTrigger
          className={buttonVariants({ variant: "outline" })}
          disabled={selectedIds.length === 0}
        >
          Actions
          <ChevronDown />
        </DropdownMenuTrigger>
        <DropdownMenuContent align="end" className="tw:w-auto">
          <DropdownMenuGroup>
            <DropdownMenuItem onClick={() => setIsDialogOpen(true)}>
              <Database />
              Set Dataset
            </DropdownMenuItem>
          </DropdownMenuGroup>
        </DropdownMenuContent>
      </DropdownMenu>
      {isDialogOpen && (
        <EventDatasetDialog
          eventIds={selectedIds}
          open
          onOpenChange={setIsDialogOpen}
          onSuccess={uncheckAll}
        />
      )}
    </>
  );
};

EventBulkActions.propTypes = {
  selectedIds: PropTypes.arrayOf(PropTypes.number).isRequired,
  uncheckAll: PropTypes.func.isRequired,
};

export default EventBulkActions;
